import { ReactNode } from 'react'

export function WidgetIconWrapper({ children, icon }: { children: ReactNode; icon: ReactNode }) {
	return (
		<div className="grid grid-cols-[auto_1fr] gap-2 items-center">
			{icon}
			<div>
				{children}
			</div>
		</div>
	)
}
